import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  DepositBalance,
  GenerateWalletDEtail,
  GenerateWalletDEtailBalance,
  GetProfile,
  GetUserWalletBalance,
  GetUserWalletDetails,
  LogoutHandler,
} from "../../../redux/auth/authSlice";
import Loader from "../../../Components/Loader/Loader";
import { GetDecryptAccessTokenformat, GetDecryptEmailformat, GetDecryptReferenceNumberformat, GetDecryptUniqId } from "../../../Components/Common/Common";
import { FaBars, FaCaretLeft } from "react-icons/fa";
import io from "socket.io-client";
import { Dropdown, Space } from "antd";
import { UserOutlined, LogoutOutlined, LockOutlined, WalletOutlined } from "@ant-design/icons";
import { Flex, Tooltip } from "antd";
import "./navbar.css";
import config from "../../../config";

const Navbar = ({ HandleToggle }) => {
  const { isLoading, getUserWalletDetails, walletBalanceUser, SolanaWalletBalance, profileDetails, SolanaWallet } = useSelector((state) => state?.counter);


  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);
  const [socket, setSocket] = useState({});

  const avatar="https://new-projectw.s3.us-east-1.amazonaws.com/newbieimage.avif"

  const [getlogoutdata, setLogoutData] = useState({});

  const [walletAddress, setWalletAddress] = useState("");
  // const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [solanaBalance, setSolanaBalance] = useState(0);

  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [form] = Form.useForm();

  // const showModal = () => {
  //   setIsModalOpen(true);
  // };

  // const handleOk = () => {
  //   form.validateFields()
  //     .then((values) => {
  //
  //       let bodydata= {
  //         senderWalletAddress:values?.senderWalletAddress,
  //         receiverWalletAddress:values?.receiverWalletAddress,
  //         amount:values?.amount,
  //         transactionHash:"3SaBP8JZ4J5irTYYi7jt1uDcmN4MRMcMHgHCqLysxUx6",
  //         transactionFee:"0.005"
  //       }
  //       dispatch(DepositBalance({bodydata,dispatch}));

  //       setIsModalOpen(false);
  //       form.resetFields();
  //     })
  //     .catch((errorInfo) => {
  //       console.error("Validation Failed:", errorInfo);
  //     });
  // };

  // const handleCancel = () => {
  //   setIsModalOpen(false);
  //   form.resetFields();
  // };

  const uniqId = GetDecryptUniqId();

  useEffect(() => {
    if (getlogoutdata?.userStatus === "deactivated") {
      localStorage.clear();
      navigate("/");
    }
  }, [getlogoutdata]);

  useEffect(() => {
    if (SolanaWallet || SolanaWalletBalance) {
      setWalletAddress(SolanaWallet?.walletAddress);
      setSolanaBalance(SolanaWalletBalance);
    }
  }, [SolanaWallet, SolanaWalletBalance]);

  const displayAddress = walletAddress?.length > 10 ? `${walletAddress.substring(0, 6)}...${walletAddress.substring(walletAddress.length - 4)}` : walletAddress;

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(walletAddress)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const text = <span>{solanaBalance?.sol === 0 ? "Please Deposit some balance." : solanaBalance?.sol + ":SOL"}</span>;

  useEffect(() => {
    // N-03: URL from config, not hardcoded.
    const socket = io(config?.api?.adminWS, {
      path: "/admin/socket.io",
      transports: ["websocket", "polling"],
      auth: {
        email: GetDecryptEmailformat(localStorage.getItem("email")),
        uniqid: uniqId,
      },

      // extraHeaders: {
      //   uniqid: uniqId,
      // },
    });

    setSocket(socket);

    socket.on("connect", () => {
      console.log("Connected to User WebSocket");
      socket.on("getLogoutData", (data) => {
        setLogoutData(data);
      });

      socket.on("error", (data) => {
        console.error("Error received:", data);
      });
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const emailData = GetDecryptEmailformat();
  const access_token = GetDecryptAccessTokenformat();

  // useEffect(() => {
  //   if (getUserWalletDetails) {
  //     dispatch(GetUserWalletBalance({ getUserWalletDetails }));
  //   }
  // }, [getUserWalletDetails]);

  useEffect(() => {
    let obj = {
      user_id: GetDecryptEmailformat(),
      email: GetDecryptEmailformat(),
      reference_number: GetDecryptReferenceNumberformat(),
    };

    if (obj?.user_id) {
      // dispatch(GetUserWalletDetails({ obj, dispatch }));
      dispatch(GenerateWalletDEtail());
      dispatch(GenerateWalletDEtailBalance());

      dispatch(GetProfile({ obj, dispatch }));
    }
  }, [dispatch]);

  // useEffect(() => {
  //   if (walletAddress && isWalletConnected) {
  //     const intervalId = setInterval(async () => {
  //       const connection = new Connection("https://api.devnet.solana.com");
  //       const publicKey = new PublicKey(walletAddress);
  //       const balance = await connection.getBalance(publicKey);
  //       setSolanaBalance(balance / LAMPORTS_PER_SOL);
  //     }, 10000);
  //     return () => clearInterval(intervalId);
  //   }
  // }, [walletAddress, isWalletConnected]);

  // useEffect(() => {
  //   const storedWalletAddress = localStorage.getItem("walletAddress");
  //   if (storedWalletAddress) {
  //     setWalletAddress(storedWalletAddress);
  //     setIsWalletConnected(true);
  //     const connection = new Connection("https://api.devnet.solana.com");
  //     const publicKey = new PublicKey(storedWalletAddress);
  //     connection.getBalance(publicKey).then((balance) => {
  //       setSolanaBalance(balance / LAMPORTS_PER_SOL);
  //     });
  //   }
  // }, []);

  // const handleConnectWallet = async () => {
  //   if (window.solana && window.solana.isPhantom) {
  //     try {
  //       const storedWalletAddress = localStorage.getItem("walletAddress");
  //       if (storedWalletAddress) {
  //         setWalletAddress(storedWalletAddress);
  //         setIsWalletConnected(true);
  //         const connection = new Connection("https://api.devnet.solana.com");
  //         const publicKey = new PublicKey(storedWalletAddress);
  //         const balance = await connection.getBalance(publicKey);
  //         setSolanaBalance(balance / LAMPORTS_PER_SOL);
  //       } else {
  //         const response = await window.solana.connect();
  //         const walletAddress = response.publicKey.toString();
  //         localStorage.setItem("walletAddress", walletAddress);
  //         setWalletAddress(walletAddress);
  //         setIsWalletConnected(true);
  //         const connection = new Connection("https://api.devnet.solana.com");
  //         const publicKey = new PublicKey(walletAddress);
  //         const balance = await connection.getBalance(publicKey);
  //         setSolanaBalance(balance / LAMPORTS_PER_SOL);
  //       }
  //     } catch (err) {
  //       console.error("Failed to connect to Phantom wallet:", err);
  //     }
  //   } else {
  //     console.error("Phantom wallet not detected!");
  //   }
  // };

  // const handleDisconnectWallet = () => {
  //   if (window.solana && window.solana.isPhantom) {
  //     window.solana.disconnect();
  //     localStorage.removeItem("walletAddress");
  //     setWalletAddress("");
  //     setIsWalletConnected(false);
  //     setSolanaBalance(0);
  //   }
  // };

  const items = [
    {
      label: (
        <div className="Navbar_css">
          <UserOutlined style={{ marginRight: 8 }} />
          Profile
        </div>
      ),
      key: "1",
      onClick: () => navigate("/profile"),
    },
    {
      label: (
        <div className="Navbar_css">
          <WalletOutlined style={{ marginRight: 8 }} />
          Wallet Details
        </div>
      ),
      key: "3",
      onClick: () => navigate("/walletdetails"),
    },
    {
      label: (
        <div className="Navbar_css">
          <LockOutlined style={{ marginRight: 8 }} />
          Change Password
        </div>
      ),
      key: "0",
      onClick: () => navigate("/changepassword"),
    },
    {
      label: (
        <div className="Navbar_css">
          <LogoutOutlined style={{ marginRight: 8 }} />
          Logout
        </div>
      ),
      key: "2",
      onClick: () => {
        let obj = {
          email: emailData,
        };
        dispatch(LogoutHandler({ obj, navigate, dispatch, socket }));
      },
    },
  ];

  const profilePictureUrl = profileDetails[0]?.profile_picture_url ? `${profileDetails[0]?.profile_picture_url}?t=${new Date().getTime()}` : avatar;
 
  const username = localStorage.getItem("UserName");

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <section className="dasboard-all top-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="header-flex">
                <ul>
                  <li>
                    <button onClick={HandleToggle} className="tog-bt">
                      <FaBars className="fa-solid fa-bars" />
                      <FaCaretLeft className="fa-solid fa-caret-left" />
                    </button>
                  </li>

                  <li className="d-flex align-items-center flex-wrap " style={{ gap: "13px" }}>
                    <div>
                      {access_token && (
                        <div
                          style={{
                            alignItems: "center",
                            display: "flex",
                            gap: "5px",
                          }}
                        >
                          {displayAddress && (
                            <div className="wallet-container">
                              <div
                                className="wallet-address"
                                title={displayAddress}
                                onClick={handleCopyClick}
                                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCopyClick(); } }}
                                role="button"
                                tabIndex={0}
                                aria-label="Copy wallet address"
                              >
                                {displayAddress}
                              </div>
                              {copied && <div className="copy-message">Copied!</div>}
                            </div>
                          )}

                          {/* <Button type="primary" onClick={showModal}>
                            Deposit
                          </Button> */}

                          {/* {!isWalletConnected ? (
                            <button onClick={handleConnectWallet} className="log-out-bt">
                              Connect Wallet
                            </button>
                          ) : (
                            <button onClick={handleDisconnectWallet} className="log-out-bt">
                              Disconnect Wallet
                            </button>
                          )} */}

                          {/* {walletAddress && (
                            <div className="wallet-container">
                              <div
                                className="wallet-address"
                                title={walletAddress}
                                onClick={handleCopyClick}
                                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleCopyClick(); } }}
                                role="button"
                                tabIndex={0}
                                aria-label="Copy wallet address"
                              >
                                {displayAddress}
                              </div>
                              {copied && <div className="copy-message">Copied!</div>}
                            </div>
                          )} */}

                          <Flex vertical justify="center" align="center" className="demo">
                            <Flex
                              justify="center"
                              align="center"
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {/* <Tooltip placement="bottom" title={text}>
                                <div>
                                  <button className="log-out-bt" style={{ cursor: "not-allowed" }}>
                                    $ {walletBalanceUser && walletBalanceUser !== "You have not enough balance 0.,please add more balance." ? walletBalanceUser : "0"}
                                  </button>
                                </div>
                              </Tooltip> */}

                              <Tooltip placement="bottom" title={text}>
                                <div>
                                  <button className="log-out-bt" style={{ cursor: "not-allowed" }}>
                                    {solanaBalance?.sol || "0"}:SOL
                                  </button>
                                </div>
                              </Tooltip>
                            </Flex>
                          </Flex>

                          {/* {isWalletConnected && (
                            <div>
                              <button className="log-out-bt" style={{ cursor: "not-allowed" }}>
                                <span>SOL Balance: {solanaBalance.toFixed(2)}</span>
                              </button>
                            </div>
                          )} */}
                        </div>
                      )}
                    </div>

                    <div className="profile-right" style={{ cursor: "pointer" }}>
                      <Dropdown
                        menu={{
                          items,
                        }}
                        trigger={["click"]}
                      >
                        <Space>
                          <div className="profile-card">
                            <div className="profile-card-img">
                              <img className="rounded-circle" src={ profilePictureUrl} height={50} width={50} alt="Profile" />
                            </div>
                            <p style={{ fontWeight: "600" }}>{username ? username : ""}</p>
                          </div>
                        </Space>
                      </Dropdown>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal
        title="Deposit Funds"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirm"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical" >
          <Form.Item
            label="Sender Wallet Address"
            name="senderWalletAddress"
            initialValue={SolanaWallet?.walletAddress}
            rules={[
              { required: true, message: "Please enter sender wallet address" },
              { min: 32, message: "Wallet address should be at least 32 characters long" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Receiver Wallet Address"
            name="receiverWalletAddress"
            rules={[
              { required: true, message: "Please enter receiver wallet address" },
              { min: 32, message: "Wallet address should be at least 32 characters long" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Amount"
            name="amount"
            rules={[
              { required: true, message: "Please enter amount" },
              { type: "number", min: 0.0001, message: "Amount must be a positive number" },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0.0001}
              step={1}
              formatter={(value) => value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(value) => value?.replace(/,/g, "")}
            />
          </Form.Item>

          <Form.Item
            label="Transaction Hash"
            name="transactionHash"
            rules={[
              { required: true, message: "Please enter transaction hash" },
              { min: 64, message: "Transaction hash must be at least 64 characters long" },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Transaction Fee"
            name="transactionFee"
            rules={[
              { required: true, message: "Please enter transaction fee" },
              { type: "number", min: 0, message: "Transaction fee must be a positive number" },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              step={0.000001}
              formatter={(value) => value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              parser={(value) => value?.replace(/,/g, "")}
            />
          </Form.Item>

        </Form>
      </Modal> */}
      </section>
    </>
  );
};

export default Navbar;
